
export class Park {
  public id: number;
  public parkDescription: string;

  public isPermitted: boolean;
  public isUnlimited: boolean;

  public totalPlacesForCompany: number;

  public overflowLevel: number;

  public maxSubsToOverflow: number;
  public overflowsInPark: number;

 public usedPlacesByGuests: number;
 public usedPlacesByRegularSubscribers: number;
 public usedPlacesByReservedSubscribers: number;
 public totalUsedPlaces: number;

 public freePlacesForRegularSubscribersAndGuests: number;
 public freePlacesForReservedSubscribers: number;

}
